import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import Modal from 'components/modal'
import { PARTNER_SELECTOR_MODAL, SUPERUSER_SELECTOR_MODAL } from 'constants/modal-constants'
import { hideModal } from 'actions/common'
import { updatePartnerSearchResults, updatePortalUserSearchResults } from 'actions/settings'
import { getCurrentModal } from 'selectors/common'
import { getPartnerSearchResults, getPortalUserSearchResults } from 'selectors/settings'

import SuperuserSelectorModalPortalUsers from './superuser-selector-modal-portal-users'
import SuperuserSelectorModalPartners from './superuser-selector-modal-partners'

export class SuperuserSelectorModalContainer extends Component {

  constructor(props) {
    super(props)
    this.handleSuperuserSearchInputChange = this.handleSuperuserSearchInputChange.bind(this)
    this.handlePartnerSearchInputChange = this.handlePartnerSearchInputChange.bind(this)
  }

  handleSuperuserSearchInputChange(e) {
    this.props.updatePortalUserSearchResults(e.target.value)
  }

  handlePartnerSearchInputChange(e) {
    this.props.updatePartnerSearchResults(e.target.value)
  }

  render() {
    const isSuperUserSelector = this.props.currentModal === SUPERUSER_SELECTOR_MODAL
    const isPartnerSelector = this.props.currentModal === PARTNER_SELECTOR_MODAL
    const isOpen = isSuperUserSelector || isPartnerSelector

    const title = isSuperUserSelector ? 'Portal User Search' : 'Partner Search'

    return (
      <Modal closeModal={this.props.hideModal} isOpen={isOpen} title={title}>
        {isSuperUserSelector ?
          <SuperuserSelectorModalPortalUsers
            handleSearchInputChange={this.handleSuperuserSearchInputChange}
            results={this.props.portalUserSearchResults}
          />
        :
          <SuperuserSelectorModalPartners
            handleSearchInputChange={this.handlePartnerSearchInputChange}
            results={this.props.partnerSearchResults}
          />
        }
      </Modal>
    )
  }

}

SuperuserSelectorModalContainer.propTypes = {
  currentModal: PropTypes.string,
  hideModal: PropTypes.func,
  partnerSearchResults: PropTypes.array,
  portalUserSearchResults: PropTypes.array,
  updatePartnerSearchResults: PropTypes.func,
  updatePortalUserSearchResults: PropTypes.func,
}

const mapStateToProps = state => ({
  currentModal: getCurrentModal(state),
  partnerSearchResults: getPartnerSearchResults(state),
  portalUserSearchResults: getPortalUserSearchResults(state),
})

const mapDispatchToProps = {
  hideModal,
  updatePartnerSearchResults,
  updatePortalUserSearchResults,
}

export default connect(mapStateToProps, mapDispatchToProps)(SuperuserSelectorModalContainer)



/** WEBPACK FOOTER **
 ** ./src/components/superuser-selector-modal/superuser-selector-modal-container.js
 **/